// Mock data for Entreterimento RJ - Rio de Janeiro Tourism Website

export const WHATSAPP_NUMBER = "+5521972232170";
export const WHATSAPP_LINK = "https://wa.me/5521972232170";
export const WHATSAPP_MESSAGE = "Olá! Quero montar um pacote no Rio de Janeiro (suítes + passeios + experiências).";
export const EMAIL = "contato@entreterimento.com.br";

export const menuItems = [
  { id: "casa-premium", label: "Casa Premium" },
  { id: "suites", label: "Suítes" },
  { id: "eventos", label: "Eventos" },
  { id: "passeios", label: "Passeios" },
  { id: "gastronomia", label: "Gastronomia" },
  { id: "motorista", label: "Motorista" },
];

export const benefits = [
  "Atendimento imediato",
  "Pacotes completos",
  "Experiência premium no Rio",
  "Roteiros personalizados",
];

// Premium House - Itanhangá Luxury Villa
export const casaPremium = {
  id: "itanhanga-luxury-villa",
  name: "Itanhangá Luxury Villa",
  nameEn: "Itanhangá Luxury Villa - Swiss Design Mansion",
  tagline: "Swiss Design & Modern Architecture in Rio de Janeiro",
  location: "Itanhangá, Rio de Janeiro",
  shortDescription: "Exclusive 2,100m² Swiss-designed mansion on 5,000m² of lush tropical land with 8 suites and infinity pool",
  description: "Experience ultimate luxury in this stunning Swiss-designed mansion nestled in the prestigious Itanhangá neighborhood. This architectural masterpiece offers 2,100m² of sophisticated living space set on 5,000m² of private tropical gardens.",
  features: [
    { icon: "Home", text: "2,100m² Built Area", textEn: "2,100m² Built Area" },
    { icon: "Trees", text: "5,000m² Private Land", textEn: "5,000m² Private Land" },
    { icon: "Bed", text: "8 Luxurious Suites", textEn: "8 Luxurious Suites" },
    { icon: "Waves", text: "Infinity Pool", textEn: "Infinity Pool with Mountain Views" },
    { icon: "Mountain", text: "Breathtaking Views", textEn: "Breathtaking Mountain Views" },
    { icon: "Shield", text: "Private & Secure", textEn: "Private & Secure Estate" },
  ],
  highlights: [
    "Swiss sophisticated design by renowned architects",
    "8 spacious suites with premium amenities",
    "Infinity pool overlooking the mountains",
    "Lush tropical vegetation for complete privacy",
    "Bright, well-planned living spaces",
    "Perfect for luxury retreats and events",
  ],
  highlightsEn: [
    "Swiss sophisticated design by renowned architects",
    "8 spacious suites with premium amenities", 
    "Infinity pool overlooking the mountains",
    "Lush tropical vegetation for complete privacy",
    "Bright, well-planned living spaces",
    "Perfect for luxury retreats and events",
  ],
  images: [
    "https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=800&q=80",
    "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&q=80",
    "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&q=80",
  ],
  videoUrl: "https://youtu.be/8ExAhBBvmFw",
  videoEmbed: "https://www.youtube.com/embed/8ExAhBBvmFw",
  price: "Consulte valores",
  priceEn: "Contact for pricing",
  seo: {
    title: "Itanhangá Luxury Villa | Swiss Design Mansion Rio de Janeiro | 8 Suites",
    description: "Rent an exclusive Swiss-designed luxury mansion in Itanhangá, Rio de Janeiro. 2,100m² built area, 8 suites, infinity pool, mountain views. Perfect for luxury retreats.",
    keywords: "luxury villa Rio de Janeiro, mansion rental Brazil, Swiss design house, Itanhangá property, luxury accommodation Rio, private estate Brazil, 8 bedroom mansion Rio",
  },
};

// Mamuska Club - Electronic Music Venue
export const mamuskaClub = {
  id: "mamuska-club",
  name: "Mamuska Club",
  nameEn: "Mamuska Club - Electronic Music Venue",
  tagline: "Rio's Premier Electronic Music Experience",
  location: "Estrada dos Bandeirantes, 12315 - Vargem Pequena, Rio de Janeiro",
  shortDescription: "Brazil's first pousada with electronic music events - the legendary 'Pousadinha' experience",
  description: "Mamuska Club is Rio de Janeiro's most unique electronic music venue, combining a boutique pousada experience with world-class DJ sets and parties. Known locally as 'Pousadinha', it's become a legendary destination for electronic music lovers from around the world.",
  features: [
    { icon: "Music", text: "Electronic Music", textEn: "World-Class Electronic Music" },
    { icon: "Users", text: "Unique Atmosphere", textEn: "Unique Party Atmosphere" },
    { icon: "Star", text: "Top DJs", textEn: "International & Local DJs" },
    { icon: "Moon", text: "Night Events", textEn: "Epic Night Events" },
    { icon: "Home", text: "Pousada Experience", textEn: "Boutique Pousada Stay" },
    { icon: "Sparkles", text: "VIP Areas", textEn: "VIP Areas Available" },
  ],
  highlights: [
    "Brazil's first pousada with electronic music events",
    "Known as 'Pousadinha' - a legendary Rio nightlife destination",
    "World-class sound system and production",
    "Regular events featuring top Brazilian and international DJs",
    "Unique blend of accommodation and nightlife",
    "Perfect for tourists seeking authentic Rio electronic music scene",
  ],
  highlightsEn: [
    "Brazil's first pousada with electronic music events",
    "Known as 'Pousadinha' - a legendary Rio nightlife destination",
    "World-class sound system and production",
    "Regular events featuring top Brazilian and international DJs",
    "Unique blend of accommodation and nightlife",
    "Perfect for tourists seeking authentic Rio electronic music scene",
  ],
  images: [
    "https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=800&q=80",
    "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=800&q=80",
    "https://images.unsplash.com/photo-1571266028243-d220c6a8b0e9?w=800&q=80",
  ],
  videoUrl: "https://youtu.be/VUK2E4FA-Mw",
  videoEmbed: "https://www.youtube.com/embed/VUK2E4FA-Mw",
  eventInfo: {
    typical: "Saturdays from 10pm to 7am",
    entry: "Free entry until midnight (varies by event)",
    vibe: "House, Techno, Electronic",
  },
  seo: {
    title: "Mamuska Club Rio de Janeiro | Electronic Music Venue | Pousadinha",
    description: "Experience Mamuska Club, Rio's legendary electronic music venue. Brazil's first pousada with DJ events. House, techno parties for tourists. The famous Pousadinha experience.",
    keywords: "Mamuska Club Rio, electronic music Rio de Janeiro, nightclub Brazil, Pousadinha Rio, techno party Rio, house music Brazil, DJ events Rio de Janeiro, nightlife Rio tourists",
  },
};

export const suites = [
  {
    id: 1,
    name: "Suíte Copacabana Premium",
    location: "Copacabana",
    description: "Perto da praia, comércio e vida noturna",
    ideal: "Ideal para casais e turistas",
    duration: "1 a 3 noites",
    image: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=600&q=80",
  },
  {
    id: 2,
    name: "Suíte Ipanema Experience",
    location: "Ipanema",
    description: "Clima sofisticado e turístico",
    ideal: "Próximo ao Arpoador",
    duration: "1 a 5 noites",
    image: "https://images.unsplash.com/photo-1618773928121-c32242e63f39?w=600&q=80",
  },
  {
    id: 3,
    name: "Suíte Barra Luxo & Conforto",
    location: "Barra da Tijuca",
    description: "Mais privacidade e tranquilidade",
    ideal: "Excelente para famílias",
    duration: "2 a 7 noites",
    image: "https://images.unsplash.com/photo-1590490360182-c33d57733427?w=600&q=80",
  },
  {
    id: 4,
    name: "Suíte Santa Teresa Charm",
    location: "Santa Teresa",
    description: "Experiência artística e histórica",
    ideal: "Vista e vibe romântica",
    duration: "1 a 4 noites",
    image: "https://images.unsplash.com/photo-1566665797739-1674de7a421a?w=600&q=80",
  },
];

export const eventos = [
  {
    id: 1,
    name: "Beach Club Mirroah",
    description: "O beach club mais exclusivo do Recreio dos Bandeirantes",
    includes: ["Área VIP", "Day use completo", "Drinks premium"],
    highlights: "Recreio dos Bandeirantes, piscina, música ao vivo",
    image: "https://images.unsplash.com/photo-1540541338287-41700207dee6?w=600&q=80",
  },
  {
    id: 2,
    name: "Faro Beach Club",
    description: "Experiência sofisticada à beira-mar no Leblon",
    includes: ["Reserva garantida", "Menu degustação", "Sunset exclusivo"],
    highlights: "Leblon, vista panorâmica, gastronomia premium",
    image: "https://images.unsplash.com/photo-1519046904884-53103b34b206?w=600&q=80",
  },
  {
    id: 3,
    name: "Rio Beach Club",
    description: "O melhor beach club da Barra da Tijuca",
    includes: ["Day use", "Espreguiçadeira VIP", "Drinks ilimitados"],
    highlights: "Barra da Tijuca, piscina infinity, DJ sets",
    image: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=600&q=80",
  },
  {
    id: 4,
    name: "Mamuska Club",
    description: "Rio's legendary electronic music venue - The famous 'Pousadinha'",
    includes: ["VIP Entry", "World-class DJs", "Unique atmosphere"],
    highlights: "Vargem Pequena, electronic music, house & techno",
    image: "https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=600&q=80",
    hasDetailPage: true,
    detailSlug: "mamuska-club",
  },
];

export const passeios = [
  {
    id: 1,
    name: "Cristo Redentor + Corcovado",
    duration: "Meio período",
    description: "O cartão postal mais famoso do Brasil",
    includes: ["Transporte", "Guia bilíngue", "Fotos profissionais"],
    image: "https://images.unsplash.com/photo-1483729558449-99ef09a8c325?w=600&q=80",
  },
  {
    id: 2,
    name: "Pão de Açúcar + Bondinho",
    duration: "Meio período",
    description: "Vista 360° da cidade maravilhosa",
    includes: ["Ingresso bondinho", "Guia", "Transporte"],
    image: "https://images.unsplash.com/photo-1544989164-31dc3c645987?w=600&q=80",
  },
  {
    id: 3,
    name: "Jardim Botânico + Parque Lage",
    duration: "Meio período",
    description: "Natureza exuberante em plena cidade",
    includes: ["Entrada", "Guia naturalista", "Brunch no café"],
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&q=80",
  },
  {
    id: 4,
    name: "Escadaria Selarón + Lapa",
    duration: "Meio período",
    description: "Arte urbana e cultura carioca",
    includes: ["Guia local", "Fotos", "História completa"],
    image: "https://images.unsplash.com/photo-1548963670-aaaa8f73a5e3?w=600&q=80",
  },
  {
    id: 5,
    name: "Museu do Amanhã + Boulevard Olímpico",
    duration: "Meio período",
    description: "Arquitetura moderna e inovação",
    includes: ["Ingresso museu", "Tour guiado", "VLT incluso"],
    image: "https://images.unsplash.com/photo-1551887196-72e32bfc7bf3?w=600&q=80",
  },
  {
    id: 6,
    name: "Praias: Copacabana, Ipanema, Leblon",
    duration: "Dia inteiro",
    description: "As praias mais famosas do mundo",
    includes: ["Guarda-sol", "Cadeiras", "Guia de praia"],
    image: "https://images.unsplash.com/photo-1518639192441-8fce0a366e2e?w=600&q=80",
  },
  {
    id: 7,
    name: "Tour Maracanã",
    duration: "Meio período",
    description: "O templo do futebol brasileiro",
    includes: ["Ingresso tour", "Guia esportivo", "Museu do Futebol"],
    image: "https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=600&q=80",
  },
  {
    id: 8,
    name: "Barra + Recreio + Grumari",
    duration: "Dia inteiro",
    description: "Praias paradisíacas e menos turísticas",
    includes: ["Transporte privativo", "Almoço", "Caiaque opcional"],
    image: "https://images.unsplash.com/photo-1519046904884-53103b34b206?w=600&q=80",
  },
];

export const gastronomia = [
  {
    id: 1,
    name: "Jantar Romântico com Vista",
    description: "Restaurantes exclusivos na Zona Sul com vista para o mar",
    includes: ["Reserva garantida", "Menu degustação", "Vinho incluso"],
    location: "Zona Sul",
    image: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=600&q=80",
  },
  {
    id: 2,
    name: "Roteiro Gastronômico Copacabana & Ipanema",
    description: "Os melhores sabores dos bairros mais famosos",
    includes: ["5 paradas", "Degustações", "Guia gastronômico"],
    location: "Copacabana e Ipanema",
    image: "https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=600&q=80",
  },
  {
    id: 3,
    name: "Experiência Brasileira: Churrasco + Caipirinha",
    description: "O melhor da culinária brasileira autêntica",
    includes: ["Rodízio completo", "Caipirinhas", "Sobremesa típica"],
    location: "Diversos locais",
    image: "https://images.unsplash.com/photo-1558030006-450675393462?w=600&q=80",
  },
  {
    id: 4,
    name: "Café da Manhã Tropical + Praia",
    description: "Comece o dia com frutas tropicais frente ao mar",
    includes: ["Buffet completo", "Sucos naturais", "Vista panorâmica"],
    location: "Orla carioca",
    image: "https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=600&q=80",
  },
  {
    id: 5,
    name: "Tour de Restaurantes + Sobremesas Famosas",
    description: "Descubra os doces e sobremesas mais tradicionais",
    includes: ["4 paradas", "Degustações ilimitadas", "Histórias locais"],
    location: "Centro e Zona Sul",
    image: "https://images.unsplash.com/photo-1551024601-bec78aea704b?w=600&q=80",
  },
];

export const motorista = [
  {
    id: 1,
    name: "Transfer Aeroporto → Hotel/Suítes",
    description: "Busca e leva nos aeroportos GIG ou SDU",
    includes: ["Carro executivo", "Wi-Fi", "Água gelada"],
    highlights: ["Conforto", "Pontualidade", "Segurança"],
    image: "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=600&q=80",
  },
  {
    id: 2,
    name: "Motorista por 4 Horas (Zona Sul)",
    description: "Disponibilidade para passeios e compromissos",
    includes: ["Carro com ar", "Motorista bilíngue", "Roteiro flexível"],
    highlights: ["Praticidade", "Economia", "Conforto"],
    image: "https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=600&q=80",
  },
  {
    id: 3,
    name: "Motorista Dia Inteiro",
    description: "Roteiro turístico completo com total liberdade",
    includes: ["8 horas", "Carro premium", "Guia opcional"],
    highlights: ["Liberdade", "Personalização", "Exclusividade"],
    image: "https://images.unsplash.com/photo-1489824904134-891ab64532f1?w=600&q=80",
  },
  {
    id: 4,
    name: "Carro Executivo para Eventos à Noite",
    description: "Transporte VIP para festas e eventos",
    includes: ["Carro de luxo", "Motorista 24h", "Discrição total"],
    highlights: ["Elegância", "Segurança", "Exclusividade"],
    image: "https://images.unsplash.com/photo-1494976388531-d1058494cdd8?w=600&q=80",
  },
  {
    id: 5,
    name: "Passeio Privativo (Barra + Grumari)",
    description: "Explore praias paradisíacas com conforto total",
    includes: ["Carro 4x4", "Paradas ilimitadas", "Cooler com bebidas"],
    highlights: ["Aventura", "Privacidade", "Natureza"],
    image: "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=600&q=80",
  },
];

export const depoimentos = [
  {
    id: 1,
    name: "Carolina M.",
    location: "São Paulo, SP",
    text: "Fechamos pacote completo e foi perfeito! Suíte linda em Ipanema, passeios incríveis e motorista super pontual.",
    rating: 5,
  },
  {
    id: 2,
    name: "Ricardo S.",
    location: "Buenos Aires, Argentina",
    text: "Atendimento rápido e passeio incrível! O tour pelo Cristo e Pão de Açúcar foi inesquecível. Recomendo!",
    rating: 5,
  },
  {
    id: 3,
    name: "Amanda L.",
    location: "Lisboa, Portugal",
    text: "A suíte era excelente e a experiência foi surreal! A noite na Lapa com samba foi o ponto alto da viagem.",
    rating: 5,
  },
  {
    id: 4,
    name: "João Pedro R.",
    location: "Belo Horizonte, MG",
    text: "Serviço impecável do início ao fim. O roteiro gastronômico superou todas as expectativas. Voltarei com certeza!",
    rating: 5,
  },
];

export const faq = [
  {
    question: "Como reservar?",
    answer: "É super simples! Basta clicar no botão de WhatsApp em qualquer pacote e entrar em contato direto conosco. Respondemos rapidamente e montamos seu pacote personalizado.",
  },
  {
    question: "Vocês montam pacote personalizado?",
    answer: "Sim! Combinamos suítes, passeios, eventos, gastronomia e motorista conforme sua preferência e orçamento. Cada viagem é única!",
  },
  {
    question: "O pagamento é antecipado?",
    answer: "Trabalhamos com sinal para confirmação e restante pode ser pago na chegada. Aceitamos PIX, cartão e transferência bancária.",
  },
  {
    question: "Atendem turistas estrangeiros?",
    answer: "Sim! Temos atendimento em português, espanhol e inglês. Nossos guias e motoristas são bilíngues.",
  },
  {
    question: "O motorista busca no aeroporto?",
    answer: "Com certeza! Oferecemos transfer dos aeroportos GIG (Galeão) e SDU (Santos Dumont) para qualquer região do Rio.",
  },
];

export const socialLinks = [
  { name: "Instagram", url: "#", icon: "Instagram" },
  { name: "TikTok", url: "#", icon: "Music" },
  { name: "YouTube", url: "#", icon: "Youtube" },
  { name: "Facebook", url: "#", icon: "Facebook" },
];
